import React, { useEffect } from 'react';
import './Error404Page.scss';
import { Helmet } from 'react-helmet-async';
import CustomBtn from '../../components/CustomBtn/CustomBtn';
import { useMediaQuery } from 'react-responsive';
import Loading from '../../components/Loading/Loading';
import { useContentQuery } from '../../services/strapi/hooks';
import { useQueryClient } from '@tanstack/react-query';
import { isExternalLink, safeHtml } from '../../services/helpers';
import StrapiImageWithSkeleton from '../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';

export default function Error404Page(
    {
        title="Oups !",
        text="La page que tu cherches est introuvable.",
        buttonText="Retour à l'accueil",
        buttonLink="/",
        image=null
    }
) {
    const isMobile = useMediaQuery({ maxWidth: 896 }); // Breakpoint pour MD

    const strapiPage = 'e404';

    const queryClient = useQueryClient();

    // Utilisation du hook personnalisé pour récupérer les données
    const { data: strapiData, isLoading, error } = useContentQuery(strapiPage);

    // Obtenir les données mises en cache ou les données actuelles
    const displayData = strapiData || queryClient.getQueryData(['strapi-content', strapiPage]);

    // N'afficher le chargement que si les données ne sont pas disponibles
    const showLoading = isLoading && !displayData;

    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    if (showLoading) return <Loading />;
    if (error) return <div>Une erreur est survenue</div>;
    if (!displayData) return <div>Aucune donnée trouvée</div>;

    return (
        <div className="error-404-page">
            <Helmet>
                <title>{displayData?.SEO.TitreOnglet}</title>
            </Helmet>
            <div className="error-404-page__content">
                <StrapiImageWithSkeleton
                    picture={displayData?.Photo}
                    size='large'
                    loading="eager"
                    fetchpriority='high'
                    className='error-404-page__picture'
                />
                <div className='error-404-page__error_text_container'>
                    <div className="error-404-page__error_text" dangerouslySetInnerHTML={safeHtml(displayData?.Texte)} />
                    <CustomBtn
                        type={isExternalLink(displayData?.Bouton.LienBouton) ? 'external' : 'internal'}
                        title={displayData?.Bouton.TexteBouton}
                        link={
                            displayData?.Bouton.LienBouton === null ?
                                '/'
                                :
                                (isExternalLink(displayData?.Bouton.LienBouton) ?
                                displayData?.Bouton.LienBouton
                                    :
                                    '/' + displayData?.Bouton.LienBouton)
                        }
                        bkg_color={'#361215'}
                        bkg_color_hover={'#EEE6DB'}
                        text_color={'#EEE6DB'}
                        text_color_hover={'#361215'}
                        border_color={'#361215'}
                        border_color_hover={'#361215'}
                        font_family={"Great Vibes"}
                        font_size={'30px'}
                        font_weight={'normal'}
                        border_radius={'3px'}
                        width={'330px'}
                        height={'60px'}
                        margin={'10px 0'}
                    />
                </div>
            </div> 
        </div>
    )
}
